import { CXoneConfiguration } from '../lib/authenticate/model/cxone-configuration';
import { HttpResponse } from '../lib/http/http-response/http-response';
import { OpenIDConfiguration } from '../lib/authenticate/model/open-id-configuration';
import {AuthToken} from "@nice-ccf/common-sdk";
import { WhoamiResponse } from '../lib/authenticate/model/whoami-response';

/**
 * This class to parse api response
 */
export class  ApiParserAuth {

    /**
     * Method to parse AuthToken response
     * 
     * @param authToken  - authToken response
     * @returns - parsed authtoken
     * @example - 
     * ```
     * parseAuthToken(authToken)
     * ```
     */
    public parseAuthToken(authToken: HttpResponse): AuthToken {
        const data = authToken.data;
        const cxOneAuthToken: AuthToken = {
            accessToken: data.access_token,
            tokenType: data.token_type,
            refreshToken: data.refresh_token,
            expiresIn: data.expires_in,
            issuedTokenType: data.issued_token_type,
            idToken: data.id_token,
            accessTokenTime: new Date().getTime(),
        };

        return cxOneAuthToken;
    }

    /**
     * 
     * @param openIDConfigResponse - open id configuration api resonse
     * @returns - parsed resopnse with required params
     * ```
     * @example
     * parseOpenIDConfigResponse(openIDConfigResponse)
     * ```
     */
    public parseOpenIDConfigResponse(openIDConfigResponse: HttpResponse): OpenIDConfiguration {
        const data = openIDConfigResponse.data;
        const discover_auth_response: OpenIDConfiguration = {
            authorizationEndpoint: data.authorization_endpoint,
            tokenEndpoint: data.token_endpoint,
            endSessionEndpoint: data.end_session_endpoint,
            displayValuesSupported: data.display_values_supported,
            codeChallengeMethods: data.code_challenge_methods_supported
          };
        return discover_auth_response;
    }
    
    /**
    * Method to parse CXoneConfiguration response
    * 
    * @param cxoneConfiguration  - cxoneConfiguration response
    * @returns - parsed cxoneConfiguration
    * @example - 
    * ```
    * parseCXoneConfiguration(cxoneConfiguration)
    * ```
    */
     public parseCXoneConfiguration(cxoneConfigResponse: HttpResponse): CXoneConfiguration {
        const data = cxoneConfigResponse.data;
        const cxoneConfig: CXoneConfiguration = {
             isUserHub:data.isUserHub,
             acdApiBaseUri: data.api_endpoint
        };
 
        return cxoneConfig;
    }

     /**
    * Method to parse whoamI api response
    * 
    * @param whoamiConfigResponse  - WhoamiResponse response
    * @returns - parsed WhoamiResponse
    * @example - 
    * ```
    * parseWhoamiResponse(whoamiConfigResponse)
    * ```
    */
      public parseWhoamiResponse(whoamiConfigResponse: HttpResponse): WhoamiResponse {
        const data = whoamiConfigResponse.data;
        const whoamiResponse: WhoamiResponse = {
            agentId: data.agent_id,
            busNo: data.bus_no,
            expiresIn: data.expires_in,
            iss: data.iss,
            refreshTokenServerUri: data.refresh_token_server_uri,
            resourceServerBaseUri: data.resource_server_base_uri.replace(/\/incontactapi\//gi,''),
            sub: data.sub,
            teamId: data.team_id,
        };
        return whoamiResponse;
     }
}